module.exports = "<uch></uch>\r\n<app-list></app-list>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appList/appListIndex.html
// module id = 251
// module chunks = 0